import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import TextInput from '../TextInput';

const MAX_ADDITIONAL_EMAILS = 6;

const SendInvoiceModal = ({ isOpen, onClose, invoice, client, onConfirm }) => {
    const [additionalEmails, setAdditionalEmails] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setAdditionalEmails(''); // Reset for next time
            setIsSending(false);
            setError('');
        }
    }, [isOpen]);

    const handleConfirm = () => {
        const emails = additionalEmails.split(',').map(e => e.trim()).filter(e => e);
        if (emails.length > MAX_ADDITIONAL_EMAILS) {
            setError(`You can include at most ${MAX_ADDITIONAL_EMAILS} additional email addresses.`);
            return;
        }
        setError('');
        setIsSending(true);
        onConfirm(additionalEmails);
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <div>
                <h2 className="text-xl font-semibold mb-4">Send Invoice</h2>

                <div className="mb-6">
                    <div className="panel-label">Client</div>
                    <div className="panel p-4">
                        <div className="font-medium">{client.firstName} {client.lastName}</div>
                        <div className="text-sm text-gray-500">{client?.email}</div>
                    </div>
                </div>

                <TextInput
                    label="Send To Additional Email Addresses (optional)"
                    placeholder="email1@example.com, email2@example.com"
                    value={additionalEmails}
                    onChange={(val) => { setAdditionalEmails(val); setError(''); }}
                    className="mb-2"
                />
                {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
                {!error && <div className="mb-4" />}

                <div className="flex gap-x-4">
                    <button className="btn-save" onClick={handleConfirm}>
                        {isSending ? 'Sending...' : 'Send Invoice'}
                    </button>

                    <button className="btn-gray-pill-lg" onClick={handleClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SendInvoiceModal;

